import { gql } from 'graphql-request'

export const setCoreUserDataMutation = gql`
  mutation SetCoreUserData($coreUserId: String!, $data: DataInput!) {
    setCoreUserData(coreUserId: $coreUserId, data: $data) {
      id
      v1Id
    }
  }
`
